module.exports = __webpack_public_path__ + "img/workshop-icon-01.b3397c2b.gif";